module.exports = __webpack_public_path__ + "img/rule-zh.f7d602c1.png";